import { useTranslation } from "react-i18next";

function ExpenseItems({
    items = [],
    onChange = () => { }
}) {

    const [t] = useTranslation(["global", "absenceReport"])

    const addItemToCart = () => {
        // Logic to add item to the cart
        const id = items.at(-1) != null ? items.at(-1).id + 1 : 1

        const item = {
            id: id,
            name: "Voce " + id,
            import: null
        }

        onChange([...items, item]);
    }

    const removeItemFromCart = (item) => {
        // Logic to remove item from the cart
        const updatedCartItems = items.filter((cartItem) => cartItem.id !== item.id);
        onChange(updatedCartItems);
    }

    function handleChange(evt, item) {
        const value = evt.target.value;
        const itemToChange = items.indexOf(item);

        const itemsCopy = items.slice()
        console.log("Trying to update item " + JSON.stringify(item) + " at index " + itemToChange + "on field " + [evt.target.name])
        itemsCopy[itemToChange][evt.target.name] = value
        //itemsCopy[itemToChange][evt.target.name] = evt.target.name == "import" ? Number(value.replace(',','.').replace(' ','')) : value
        onChange(itemsCopy);
    }

    return (
        <div>
            {/* Code to display cart items */}
            <div>
                <hr />
                {
                    items.length == 0 &&
                    "Nessuna voce di spesa..."
                }
                {items.map((item) => (
                    <>
                        <div className="row" key={item.id}>
                            <div className="col-sm-4">
                                <input type="text" className="form-control" name="name" value={item.name} onChange={(e) => handleChange(e, item)} placeholder="Desc" required />
                            </div>
                            <div className="col-sm-3">
                                <input type="number" min="0" className="form-control" name="import" value={item.import} onChange={(e) => handleChange(e, item)} placeholder="€" required />
                            </div>
                            {/* <div className="col-sm-3">
                                <input type="file" id="attachment" name="attachment" accept="image/png, image/jpeg" onChange={(e) => handleChange(e, item)} />
                            </div> */}
                            <div className="col text-end">
                                <button className="btn btn-danger  btn-sm" onClick={() => removeItemFromCart(item)}>X</button>
                            </div>
                        </div>
                        <hr />
                    </>
                ))}
                <div className="row text-end">
                    <div className="col">
                        <h4>€{parseFloat(items.reduce((partialSum, a) => partialSum + Number(a.import), 0)).toFixed(2)}</h4>
                    </div>
                    <div className="col">
                        <button className="btn btn-primary small" onClick={() => addItemToCart()}>{t("action.add")}</button>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default ExpenseItems